/** dnd-kit drag/drop id encoding — keeps Canvas.tsx's onDragEnd handler simple and string-based. */
export type DragId =
  | { kind: 'palette'; fieldType: string }
  | { kind: 'field'; fieldId: string }
  | { kind: 'section'; sectionId: string }
  | { kind: 'section-body'; sectionId: string };

export function encodeDragId(id: DragId): string {
  switch (id.kind) {
    case 'palette':
      return `palette:${id.fieldType}`;
    case 'field':
      return `field:${id.fieldId}`;
    case 'section':
      return `section:${id.sectionId}`;
    case 'section-body':
      return `section-body:${id.sectionId}`;
  }
}

export function decodeDragId(raw: string): DragId | null {
  const sep = raw.indexOf(':');
  if (sep < 0) return null;
  const kind = raw.slice(0, sep);
  const value = raw.slice(sep + 1);
  switch (kind) {
    case 'palette':
      return { kind: 'palette', fieldType: value };
    case 'field':
      return { kind: 'field', fieldId: value };
    case 'section':
      return { kind: 'section', sectionId: value };
    case 'section-body':
      return { kind: 'section-body', sectionId: value };
    default:
      return null;
  }
}
